import { ActionReducerMapBuilder, createSlice } from "@reduxjs/toolkit";
import {
  clearScholarships,
  createScholarship,
  deleteScholarship,
  editScholarship,
  getScholarships,
} from "../actions/scholarship";
import { SCHOLARSHIP_FORM } from "../@types";

interface SCHOLARSHIP_INITIAL_STATE {
  scholarships: Array<SCHOLARSHIP_FORM>;
  status: "idle" | "pending" | "succeeded" | "failed";
  error: any;
}

const initialState: SCHOLARSHIP_INITIAL_STATE = {
  scholarships: [],
  status: "idle",
  error: null,
};

const scholarshipsSlice = createSlice({
  name: "scholarships",
  initialState,
  reducers: {},

  extraReducers(builder: ActionReducerMapBuilder<SCHOLARSHIP_INITIAL_STATE>) {
    builder.addCase(getScholarships.rejected, (_state, action) => ({
      ...initialState,
      status: "failed",
      error: action,
    }));
    builder.addCase(getScholarships.fulfilled, (state, action) => ({
      scholarships: action.payload,
      error: null,
      status: "succeeded",
    }));
    builder.addCase(createScholarship.fulfilled, (state, action) => {
      //might be an error here
      const { scholarshipp } = action.payload;
      const newArr = JSON.parse(JSON.stringify(state.scholarships));
      newArr.push(scholarshipp);
      state.scholarships = newArr;
    });
    builder.addCase(createScholarship.rejected, (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    });
    builder.addCase(deleteScholarship.fulfilled, (state, action) => {
      const scholarshipId = action.payload;
      const newArr = JSON.parse(JSON.stringify(state.scholarships));
      const scholarshipIdx = state.scholarships.find(
        (p) => p.id === scholarshipId
      );
      newArr.splice(scholarshipIdx, 1);
      state.scholarships = newArr;
    });
    builder.addCase(clearScholarships.fulfilled, () => ({
      ...initialState,
    }));
    builder.addCase(editScholarship.fulfilled, (state, action) => {
      const scholarshipToEdit: SCHOLARSHIP_FORM =
        action.payload as unknown as SCHOLARSHIP_FORM;
      const newArr = JSON.parse(
        JSON.stringify(state.scholarships)
      ) as unknown as Array<SCHOLARSHIP_FORM>;
      const scholarshipIdx = state.scholarships.findIndex(
        (p) => p.id === scholarshipToEdit.id
      );
      newArr[scholarshipIdx] = scholarshipToEdit;
      state.scholarships = newArr;
    });
  },
});

export default scholarshipsSlice.reducer;
